<template>
  <div id="MozliweAkumulatory">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false">
      <!-- {{outputs.mozliwe_akumulatory}} -->
      <!-- {{config.glebokosc.value}} -->
      <div style="width:100%; padding:5px">
      <md-button class="md-primary" style="position: relative; width: 80px; float: right;" @click="closeDialog(0)">{{$t('message.zamknij')}}</md-button>
      </div>
      <md-dialog-title style="padding: 0px 20px">{{$t('message.wybierz_akumulatory')}}</md-dialog-title>
      <div id="content">
        <div id="batteries600" class="batteries" v-if="config.glebokosc.value.indexOf('600') > -1">
          <!-- Dla szafy o głębokości 600 -->
          <ul>
            <li v-for="(item, index) in outputs.mozliwe_akumulatory" :key='index'>
              <button @click="changeBattery(item.gen_code)" class="btn">{{item.label}}</button>
            </li>
          </ul>
        </div>
        <!-- <div id="batteries800" class="batteries" v-if="config.glebokosc.value.indexOf('800') > -1">
          Dla szafy o głębokości 800
          <ul>
            <li v-for="(item, index) in outputs.mozliwe_akumulatory['800']" :key='index'>
              <button @click="changeBattery(item.gen_code,'800')" class="btn">{{item.label}}</button>
            </li>
          </ul>
        </div> -->
      </div>
    </md-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { app } from '../../mixins/app'
import { materials } from '../../mixins/materials'
import { calculation } from '../../mixins/calculation'

export default {
  name: 'MozliweAkumulatory',
  mixins: [app, materials, calculation],
  props: ['showDialog'],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesoria']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaZasilacze']),
    ...mapGetters('products', ['ListaListwyD']),
    ...mapGetters('products', ['ListaListwyZ']),
    ...mapGetters('products', ['ListaMaterialy'])
  },
  methods: {
    closeDialog () {
      this.$emit('clickedClose', false)
    },
    changeBattery (kod) {
      let battery = this.outputs.mozliwe_akumulatory.filter(item => item.gen_code === kod)
      battery.user = true

      this.changeValueOutputs('akumulator_user', 'value', true)
      this.changeValueOutputs('akumulator', 'array', battery[0])
      this.$emit('clickedClose', false)
      this.obliczenia_sprzetu()
    }
  }
}
</script>

<style scoped>
div.md-dialog {
  background: rgba(0,0,0,0.6);
}
div.md-dialog div {
  background: rgb(255, 255, 255);
  width: 520px;
  max-width: 520px;
  padding: 10px;
}
.md-dialog-title {
    margin-bottom: 0px;
    padding: 24px 24px 0;
}
.btn {
  padding:4px;
  font-size: 14px;
  height: 24px;
  line-height: 5px;
}
#content {
  font-size: 16px;
  line-height: 24px;
}
.batteries {
  width: 500px !important
}
.batteries ul {
  display: grid;
  margin-bottom: 0px;
}
.batteries ul li {
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/MozliweAkumulatory.vue